// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--2vqfG";
export var form = "styles-module--form--DgQnl";
export var loadingOverlay = "styles-module--loadingOverlay--3L9af";
export var active = "styles-module--active--37BZ0";
export var compactWrapper = "styles-module--compactWrapper--BXdIi";
export var buttonWrapper = "styles-module--buttonWrapper--3pS_X";
export var invalid = "styles-module--invalid--2n9Uv";
export var sentWrapper = "styles-module--sentWrapper--2w94y";